module.exports = __webpack_public_path__ + "img/icon-try-on.black.88f89113.svg";